import { createSelector } from 'reselect'

const data = entry => ({ entry })

const mapForDropdown = ({ entry }) => {
  return entry.map(item => ({
    label: item.name || '---',
    value: item.id || '---'
  }))
}

export default createSelector(data, mapForDropdown)
